<template>
  <div class="manageUser">
      <div class="content">
      <div class="search">
        <van-search
          v-model="value"
          show-action
          placeholder="请输入搜索用户名"
          @search="onSearch"
          @input="onSearch"
        >
          <template #action>
            <div @click="onSearch(value)">搜索</div>
          </template>
        </van-search>
        <span style="color: #fa8f04;font-weight: bold; font-size: 13px;
        float: right;margin-right: 6%;">{{ queryDataLength }}</span>
        <van-divider />
      </div>

        <!-- 添加 -->
        <div class="addUser add-contact-card" role="button" tabindex="0" @click="onAdd">
          <van-icon name="add" class="van-add__left-icon"/>
          <div class="add-value add-value__alone">添加服务站用户</div>
          <van-icon name="arrow" class="van-add__right-icon"/>
        </div>

        <!-- 查询到的用户列表 -->
        <div class="addUser add-contact-card" role="button" tabindex="0" @click="onEdit(item)" 
          v-for="item in responseDataArray" :key="item.id">
        <van-icon name="user" class="user__left-icon"/>
        <!-- <div class="add-value add-value__alone"  >用户名：{{ item.name }}</div>
        <van-button @click.stop="onDelete(item)">删除</van-button> -->
         <van-row style="width: 100%;">
          <van-col :span="19">
            <van-row style="height: 30px;">
              <div class="add-value add-value__alone"  >用户名：{{ item.name }}</div>
            </van-row>
            <van-row style="height: 30px;">
              <div class="add-value add-value__alone"  >服务站：{{ item.stationDescription }}</div>
            </van-row>
          </van-col>
          <van-col :span="5"><van-button style="padding: 0;width: 100%;" @click.stop="onDelete(item)">删除</van-button></van-col>
         </van-row>
        
        </div>
      </div>
      <!-- 编辑 -->
      <van-overlay :show="exitShow" @click="exitShow=false">
        <div class="manageWrapper" @click.stop>
          <div class="manageBlock">
            <van-form ref="exitForm">
              <div class="title">
              <span>编辑</span>
            </div>
              <van-field label="服务站：" v-model="showList.stationDescription" disabled/>
              <van-field label="姓名：" v-model="showList.name"/>
              <van-field label="身份证号码：" v-model="showList.idNo" disabled/>
              <van-field label="密码：" v-model="showList.password" :type="exitPasswordType" style="padding: 6px 12px;">
                <template #input>
                  <van-button  hairline style="width: 100%;" type="warning" @click="resetPassword">重 置 密 码</van-button>
                </template>
                <!-- <template slot="right-icon">
                  <span class="slots" @click="switchPasswordType('exit')" >
                    <van-icon name="browsing-history-o" v-if="exitPasswordType === 'text'" />
                    <van-icon name="closed-eye" v-else color="black"/>
                  </span>
                </template> -->
              </van-field>
              <van-field label="手机号：" v-model="showList.phone"/>
              <van-field label="创建时间： " v-model="showList.createTime" disabled>{{ showList.createTime | formatTime }}</van-field>
              <!-- <van-field label="类型： " :disabled="manageTypeDisabled">
                <template #input>
                  <van-radio-group v-model="showList.role" :disabled="manageTypeDisabled">
                    <van-radio :name= 0 checked-color="#3399ff">超级管理员</van-radio>
                    <van-radio :name= 1 checked-color="#3399ff">管理员</van-radio>
                    <van-radio :name= 2 checked-color="#3399ff">职员</van-radio>
                  </van-radio-group>
                </template>
              </van-field> -->
              <van-field label="状态： "  :disabled="manageTypeDisabled">
                <template #input>
                  <van-radio-group v-model="showList.state" direction="horizontal" :disabled="manageTypeDisabled">
                    <van-radio :name= 0 checked-color="#3399ff">正常</van-radio>
                    <van-radio :name= 1 checked-color="#3399ff">禁用</van-radio>
                  </van-radio-group>
                </template>
              </van-field>
            </van-form>
            <div style="margin: 16px;">
              <van-row style="margin-top: 2%;">
                <van-col :span="12">
                  <van-button @click="cancel" plain hairline type="info" class="buttons">取消</van-button>
                </van-col>
                <van-col :span="12">
                  <van-button @click="confirm" plain hairline type="info" class="buttons">确认</van-button>
                </van-col>
              </van-row>
            </div>
          </div>
        </div>
      </van-overlay>
      <!-- 新增 -->
      <van-overlay :show="addShow" @click="addShow=false">
        <div class="manageWrapper" @click.stop>
          <div class="manageBlock">
          <van-form ref="addForm" label-width="90px">
            <div class="title">
              <span>添加服务站管理员</span>
            </div>
            <van-row>
              <van-col :span="8">
                <van-cell class="titleStyle">服务站：</van-cell>
              </van-col>
              <van-col :span="16" class="select picker">
                <van-field
                  readonly
                  clickable
                  :value="getPlateValue"
                  placeholder="点击选择服务站"
                  @click="showPicker = true"
                />
                <van-popup v-model="showPicker" round position="bottom">
                  <van-picker
                    show-toolbar
                    title="下划查看更多服务站"
                    :columns="addStationUserOption"
                    :visible-item-count="9"
                    @cancel="showPicker = false"
                    @confirm="onConfirm"
                  />
                </van-popup>
              </van-col>
            </van-row>
            <van-field label="姓名：" v-model="addUserForm.name" placeholder="姓名"/>
            <van-field label="身份证号：" v-model="addUserForm.idNo" placeholder="身份证号" maxlength="18"/>
            <van-field label="密码：" 
              v-model="addUserForm.password" 
              error
              placeholder="初始密码为身份证号后六位"
              :type="passwordType" readonly>
              <!-- <template>
                <span>初始密码为身份证号后六位</span>
              </template> -->
              <!-- <template slot="right-icon">
                <span class="slots" @click="switchPasswordType('add')" >
                  <van-icon name="browsing-history-o" v-if="passwordType === 'text'" />
                  <van-icon name="closed-eye" v-else color="black"/>
                </span>
            </template> -->
            </van-field>
            <van-field label="手机号：" 
              v-model="addUserForm.phoneNo" 
              placeholder="手机号" 
              type="tel"
              maxlength="11"/>
            <!-- <van-field label="姓名：" v-model="addUserForm.name" placeholder="姓名"
            :rules="[{required:true,message:'请输入姓名'}]"/>
            <van-field label="用户名：" v-model="addUserForm.idNo" placeholder="用户名"
            :rules="[{required:true,message:'请输入用户名'}]"/>
            <van-field label="密码：" v-model="addUserForm.password" placeholder="密码" :type="passwordType"
            :rules="[{required:true,message:'请输入密码'}]">
              <template slot="right-icon">
                <span class="slots" @click="switchPasswordType('add')" >
                  <van-icon name="browsing-history-o" v-if="passwordType === 'text'" />
                  <van-icon name="closed-eye" v-else color="black"/>
                </span>
            </template>
            </van-field>
            <van-field label="手机号：" 
              v-model="addUserForm.phoneNo" 
              placeholder="手机号" 
              type="tel"
              maxlength="11"
              :rules="[{required:true,pattern:/^1[3456789]\d{9}$/,message:'请输入手机号码'}]"
              /> -->
            <!-- <van-field label="类型： " v-model="addUserForm.verifyCode" >
              <template #input>
                <van-radio-group v-model="addUserForm.role">
                  <van-radio :name= 0 checked-color="#3399ff">超级管理员</van-radio>
                  <van-radio :name= 1 checked-color="#3399ff">管理员</van-radio>
                  <van-radio :name= 2 checked-color="#3399ff">职员</van-radio>
                </van-radio-group>
              </template>
            </van-field> -->
            <van-field label="状态： " >
              <template #input>
                <van-radio-group v-model="addUserForm.state" direction="horizontal">
                  <van-radio :name= 0 checked-color="#3399ff">正常</van-radio>
                  <van-radio :name= 1 checked-color="#3399ff">禁用</van-radio>
                </van-radio-group>
              </template>
            </van-field>
          </van-form>
            <div style="margin: 16px;">
                <van-row style="margin-top: 2%;">
                  <van-col :span="12">
                    <van-button @click="addCancel" plain hairline type="info" class="buttons">取消</van-button>
                  </van-col>
                  <van-col :span="12">
                    <van-button @click="addConfirm" plain hairline type="info" class="buttons">确认</van-button>
                  </van-col>
                </van-row>
            </div>
        
          </div>
        </div>
      </van-overlay>
  </div>
</template>

<script>
import {AddStationUser,DeleteStationUser,ModifyStationUser,QueryStationUser,QueryStationDic} from '@/my_js/HttpRequest.js'
import {formatTime} from '@/utils/date.js'
import { Dialog } from 'vant'
import { Notify } from 'vant'
import {WarningMsgBox} from '@/my_js//common.js'
import md5 from 'js-md5'
import store from '../../store/index'
export default {
  mounted(){
    this.onSearch()
    this.getStationDic()
  },
  components:{

  },
  filters:{
    formatTime:function(inputTime){
     return formatTime(inputTime)
    },
    formatType:function(inputValue){
      if(inputValue == 0){
        return '超级管理员'
      }else if (inputValue == 1){
        return '管理员'
      }else if (inputValue == 2){
        return '职员'
      }
    },
    formatState:function(inputState){
      if(inputState == 0){
        return '正常'
      }else if (inputState == 1){
        return '禁用'
      }
    }
  },
  data(){
    return{
      exitPasswordType:'password',//密码框输入类型
      passwordType:'password',//密码框输入类型
      value:'',//搜索内容
      responseDataArray:[],//响应数据
      exitShow:false,//编辑显示
      showList:[],//编辑展示的数据
      exitData:[],//编辑后的数据
      addUserForm:{
        idNo:'',//身份证号
        name:'',//用户姓名
        // userName:'',//用户名
        password: '',//密码
        phoneNo: '',//手机号
        state: 0,//状态
        role: 0,//角色类型 超级管理员、管理员、职员
        faceFeature: '',
        stationCode: '',//服务站
      },
      addShow:false,//添加用户
      manageTypeDisabled:false,//管理员类型禁用
      getPlateValue:'',//服务站
      showPicker: false,//选项是否显示
      addStationUserOption:[],//下拉框选项
      queryDataLength:null,//查询到的数据量
      
    }
  },
  methods:{
    // 返回
    goBack(){
      console.log('返回管理员首页');
      this.$router.push('/manager')
    },
    // 获取服务站信息
    getStationDic(){
        QueryStationDic().then(res => {
          console.log(res);
          this.stationsDicInfo = res.data
          console.log('stationsDicInfo',this.stationsDicInfo);
          this.stationsDicInfo.forEach(element => {
            this.addStationUserOption.push({text:element.name,value:element.code,getStation:element.getStation})
          });
          console.log('服务站信息:',this.stationOption);
        })
        },
    // 查询用户
    onSearch(val){
      console.log(val);
      const data = {
        userName: this.value,
      }
      QueryStationUser(data).then(res => {
        console.log('查询用户res',res);
        this.responseDataArray = res.data
        this.queryDataLength = this.responseDataArray.length
      })
      // if( store.state.role == 0){
      //   const data = {
      //     userName: this.value,
      //   }
      //   QueryUser(data).then(res => {
      //     console.log('查询用户res',res);
      //     this.responseDataArray = res.data
      //   })
      // }else{
      //   console.log(store.state.userName);
      //   QueryUser({userName:store.state.userName}).then(res => {
      //     console.log('查询用户res',res);
      //     this.responseDataArray = res.data
      //   })
      // }
    },
    // 添加用户
    onAdd(){
      console.log('添加用户');
      // this.addShow = true
      if(store.state.role == 0){
        this.addShow = true
      }else{
        Notify({type:'warning',message:'当前账号没有该操作权限'})
      }
    },
    addConfirm(){
      console.log(this.addUserForm);
      // debugger
      const validIdNo = this.validateIdCard(this.addUserForm.idNo)
      const validPhoneNo = this.validatePhoneNo(this.addUserForm.phoneNo)
      
      if(this.getPlateValue == '' || this.getPlateValue == null){
          WarningMsgBox('请选择号牌领取点')
        }else if(this.addUserForm.name == ''){
          WarningMsgBox('请输入姓名')
        }else if(!validIdNo){
          WarningMsgBox('请输入正确的身份证号')
        }else if(!validPhoneNo){
          WarningMsgBox('请输入正确的手机号')
        }else{
          const password = this.addUserForm.idNo.substring(12,18)
          const psd = md5(this.trimmedStr(password)).toUpperCase()
          // console.log(this.addUserForm.idNo.substring(12,18));
          // console.log(md5(this.trimmedStr(this.addUserForm.idNo.substring(12,18))).toUpperCase());
          const addManageArray = {
            idNo:this.addUserForm.idNo,//身份证号码
            name:this.addUserForm.name,//用户姓名
            userName:this.addUserForm.idNo,//用户名
            password: psd,//密码
            phoneNo: this.addUserForm.phoneNo,//手机号
            state: this.addUserForm.state,//状态
            role: this.addUserForm.role,//角色类型 超级管理员、管理员、职员
            faceFeature: '',
            stationCode: this.addUserForm.stationCode,//服务站
          }
          console.log('addManageArray',addManageArray);
          
          AddStationUser(addManageArray).then(res =>{
          console.log('添加用户res',res);
          this.addShow = false
          this.addUserForm={
            idNo:'',//身份证号
            name:'',//用户姓名
            // userName:'',//用户名
            password: '',//密码
            phoneNo: '',//手机号
            state: 0,//状态
            role: 0,//角色类型 超级管理员、管理员、职员
            faceFeature: '',
            stationCode: '',//服务站
          },
          this.getPlateValue = '';
          Notify({type:'success',message:'添加'+res.msg})
          this.onSearch()
        })
        }
       
      // this.$refs.addForm.validate()
      // .then(valid => {
      //     // 表单验证成功
      //     console.log('验证通过');
      //     const psd = md5(this.trimmedStr(this.addUserForm.password)).toUpperCase()
      //     const addManageArray = {
      //       idNo:'',//身份证号码
      //       name:this.addUserForm.name,//用户姓名
      //       userName:this.addUserForm.idNo,//用户名
      //       password: psd,//密码
      //       phoneNo: this.addUserForm.phoneNo,//手机号
      //       state: this.addUserForm.state,//状态
      //       role: this.addUserForm.role,//角色类型 超级管理员、管理员、职员
      //       faceFeature: '',
      //       stationCode: this.addUserForm.stationCode,//服务站
      //     }
      //     AddStationUser(addManageArray).then(res =>{
      //     console.log('添加用户res',res);
      //     this.addShow = false
      //     this.addUserForm={
      //     name:'',//用户姓名
      //     userName:'',//用户名
      //     password: '',//密码
      //     phoneNo: '',//手机号
      //     state: 0,//状态
      //     role: 0,//角色类型 超级管理员、管理员、职员
      //     },
      //     Notify({type:'success',message:'添加'+res.msg})
      //     this.onSearch()
      //   })
      // })
      // .catch(error => {
      //   console.log('验证不通过');
      //   console.log('Validation failed:',error);
      // })
    },
    // 取消添加用户
    addCancel(){
      console.log('取消添加用户');
      this.addShow = false
      this.addUserForm={
        idNo:'',//身份证号
        name:'',//用户姓名
        // userName:'',//用户名
        password: '',//密码
        phoneNo: '',//手机号
        state: 0,//状态
        role: 0,//角色类型 超级管理员、管理员、职员
        faceFeature: '',
        stationCode: '',//服务站
      }
      this.getPlateValue = '';
    },
    // 编辑
    onEdit(val){
      // console.log(md5(this.trimmedStr('218922')).toUpperCase());
      // return
      console.log('编辑用户');
      console.log(val);
      this.showList = val
      // this.exitData = val
      this.showList.createTime = formatTime(this.showList.createTime)
      if(store.state.role !== 0){
        this.manageTypeDisabled = true
      }
      this.exitShow = true
      console.log('修改前数据：',this.showList);
    },
     // 提交修改表单
     confirm(){
      Dialog.confirm({
        title:'消息确认',
        message:`是否确定修改该用户的信息？`
      }).then(()=>{
        // 修改请求
        console.log('点击了确定修改');
        // const psd = md5(this.trimmedStr(this.showList.password)).toUpperCase()
        // this.exitData.password = psd
        // console.log('修改后数据：',this.exitData);
        console.log('showList',this.showList);
        
        ModifyStationUser(this.showList).then(res => {
          console.log('修改res:',res);
          this.exitShow = false
          Notify({type:'success',message:'修改'+res.msg})
        })
        this.onSearch()
      }).catch(error =>{
        console.log(error);
      })
    },
    // 取消修改
    cancel(){
        console.log('点击了取消修改');
        this.exitShow = false
        this.onSearch()
        this.exitPasswordType = 'password'
      },
    // 删除用户
    onDelete(val){
      console.log('删除用户');
      if(store.state.userName === val.userName){
       Notify({type:'warning',message:'不能删除当前登录用户'})
      }else{
        Dialog.confirm({
          title:'提示',
          message:`确认删除 ${val.name} ？`
        }).then(()=>{
          // 确认删除用户
          DeleteStationUser(val).then(res =>{
          console.log('删除用户',res);
          Notify({type:'success',message:'删除'+res.msg})
          this.onSearch()
        })
        }).catch(error=>{
          console.log(error);
        })
      }
    },
    // 密码图标切换
    switchPasswordType(val){
      console.log(val);
      if(val == 'add'){
        this.passwordType = this.passwordType === 'password'?'text':'password'
      }else if(val == 'exit'){
        this.exitPasswordType = this.exitPasswordType === 'password'?'text':'password'
      }
      // this.passwordType = this.passwordType === 'password'?'text':'password'
    },
    // 去除空格
    trimmedStr(str){
      return str.replace(/\s+/g,'')
    },
    // 服务站选项发生变化
    onConfirm(val) {
        console.log('用户选择的服务站',val);
        this.getPlateValue = val.text;
        this.showPicker = false;
        this.addUserForm.stationCode = val.value
    },
    // 验证身份证号
    validateIdCard(value){
      const reg = /(^\d{8}(0\d|10|11|12)([0-2]\d|30|31)\d{3}$)|(^\d{6}(18|19|20)\d{2}(0[1-9]|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$)/
      return (reg.test(value))
    },
    // 验证手机号
    validatePhoneNo(value){
      const regex = /^1[3-9]\d{9}$/;
      return regex.test(value); 
    },
    // 服务站用户重置密码
    resetPassword(){
      console.log('点击了重置密码');
      Dialog.confirm({
          title:'提示',
          message:`确认重置该用户密码为身份证后六位？`
        }).then(()=>{
          // 确认重置用户密码
          console.log(this.showList.idNo.substring(12,18));
          const psd = this.showList.idNo.substring(12,18)
          this.showList.password = md5(this.trimmedStr(psd)).toUpperCase()
          console.log('showList',this.showList);
          // console.log(md5(this.trimmedStr('218922')).toUpperCase());
          ModifyStationUser(this.showList).then(res =>{
          console.log('重置用户密码',res);
          Notify({type:'success',message:'重置密码'+res.msg})
          this.onSearch()
          this.exitShow = false
        })
        }).catch(error=>{
          console.log(error);
        })
      
    },
    
   
  }

}
</script>

<style lang="scss" >
.manageUser{
  .van-nav-bar__left{
    left: 0;
  }
  .van-nav-bar .van-icon{
    color: #0283ef;
  }
  .van-nav-bar__text{
    color: #0283ef;
  }
  .van-search__action{
    color: #0283ef;
    font-size: 18px;
  }
  .addUser {
  position: relative;
  display: flex;
  box-sizing: border-box;
  width: 100%;
  overflow: hidden;
  color: #111;
  font-size: 25px;
  line-height: 50px;
  background-color: #fff;
  .user__left-icon{
  line-height: 60px;
  height: 60px;
  font-size: 22px;
  color: #0283ef;
}
}

.addUser::before {
  position: absolute;
  right: 0;
  left: 0;
  bottom: 0;
  height: 1px;
  // background: repeating-linear-gradient(-45deg, #ff6c6c 0, #ff6c6c 20%, transparent 0, transparent 25%, #0283ef 0, #0283ef 45%, transparent 0, transparent 50%);
  // background-size: 95px;
  background: repeating-linear-gradient(-180deg, #f0efef 0, #f0efef 20%, 
  transparent 0, transparent 25%, #f0efef 0, #f0efef 45%, transparent 0, transparent 50%);
  background-size: 150px;
  content: '';
}

.add-user-clickable {
  cursor: pointer;
}

.add-user-center {
  display: flex;
  align-items: center;
}
.add-value{
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
  -webkit-box-flex: 5;
  flex: 5;
}
.add-value__alone{
  color: #333;
  text-align: left;
  font-size: 16px;
  margin-left: 8px;
}

.add-contact-card {
  padding: 0 10px 15px 10px;
}

.van-add__left-icon {
  color: #0283ef;
  font-size: 35px;
}
.van-radio{
  padding-bottom:3px ;
}
.van-add__right-icon{
  margin-left: 10px;
  font-size: 18px;
  color: #999;
}

.van-add__left-icon, .van-add__right-icon {
  min-width: 30px;
  height: 50px;
  line-height: 50px;
}

.manageWrapper{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    .manageBlock{
    width: 95%;
    // height: 76%;
    border-radius: 8px;
    background-color: #fff;
    .title{
    margin-top: 3%;
    }

    .van-cell__value{
      text-align: left;
    }
    .buttons{
      width: 90%;
    }
  }
  }
 .picker{
  .van-picker__title{
      color: #fa8f04;
      font-weight: bold;
    }
 }
 
}
.van-dialog__confirm {
    background-color: #0094ff; /* 确认按钮背景色 */
    color: #fff; /* 确认按钮字体颜色 */
  }
</style>